import React, { useState, useEffect } from 'react'; // Added useState and useEffect
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'; // Added Navigate
import { auth } from './firebase'; // Import auth
import { onAuthStateChanged } from 'firebase/auth'; // Import auth listener

import Home from './pages/Home';
import OurBunnies from './pages/OurBunnies';
import AvailableBunnies from './pages/AvailableBunnies';
import PastBabies from './pages/PastBabies';
import Application from './pages/Application';
import Merchandise from './pages/Merchandise';
import Contact from './pages/Contact';
import AdminDashboard from './pages/AdminDashboard';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import Footer from './Footer';
import Navbar from './Navbar';
import './App.css'; // This will contain the Navy and Rose CSS from the previous step

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  // Only the admin route waits on auth; public pages render immediately so
  // crawlers and visitors aren't held behind the Firebase auth check.
  const adminElement = loading
    ? <div style={{ textAlign: 'center', padding: '50px' }}>Loading...</div>
    : user ? <AdminDashboard /> : <Navigate to="/login" />;

  return (
    <Router>
       <HelmetProvider>
          <div className="App">

            {/* The ONLY Navbar you need */}
            <Navbar />

            {/* Page Routing */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/our-bunnies" element={<OurBunnies />} />
              <Route path="/available" element={<AvailableBunnies />} />
              <Route path="/past-babies" element={<PastBabies />} />
              <Route path="/application" element={<Application />} />
              <Route path="/merchandise" element={<Merchandise />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={adminElement} />
              <Route path="*" element={<NotFound />} />
            </Routes>

            <Footer />

          </div>
       </HelmetProvider>
    </Router>
  );
}

export default App;